import React from "react";
import { GoogleMap, MarkerF, useLoadScript } from "@react-google-maps/api";

const LoadMap = (props) => {
    const googleMapsApiKey = process.env.REACT_APP_GOOGLE_API_KEY;

    const containerStyle = {
        width: props.width,
        height: props.height,
        pointerEvents: "none", // disables map interaction to allow click-through
    };

    const { isLoaded } = useLoadScript({
        googleMapsApiKey: googleMapsApiKey,
    });

    const newPosition = {
        lat: parseFloat(props.locationLat),
        lng: parseFloat(props.locationLong),
    };

    const handleMapClick = () => {
        const googleMapsUrl = `https://www.google.com/maps?q=${newPosition.lat},${newPosition.lng}`;
        window.open(googleMapsUrl, "_blank");
    };

    return (
        <div className="event-service-map" onClick={handleMapClick} style={{ position: "relative", cursor: "pointer" }}>
            {isLoaded && (
                <div style={{ pointerEvents: "none" }}>
                    <GoogleMap
                        mapContainerStyle={containerStyle}
                        zoom={15}
                        center={newPosition}
                    >
                        <MarkerF position={newPosition} />
                    </GoogleMap>
                </div>
            )}
        </div>
    );
};

export default LoadMap;
